// extracted by mini-css-extract-plugin
export default {"wrap":"AvatarMenu_wrap__AN5vB","menuItem":"AvatarMenu_menuItem__DzqFw","icon":"AvatarMenu_icon__laRkV","signOut":"AvatarMenu_signOut__cj+8D"};